import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from './firebase';

export function usePendingRentalCount(user) {
  const [pendingRentalCount, setPendingRentalCount] = useState(0);
  const [pendingRentalIds, setPendingRentalIds] = useState(() => new Set());

  useEffect(() => {
    if (!user?.uid) {
      setPendingRentalCount(0);
      setPendingRentalIds(new Set());
      return undefined;
    }

    const pendingQuery = query(
      collection(db, 'rentals'),
      where('ownerId', '==', user.uid),
      where('status', '==', 'pending')
    );

    const unsubscribe = onSnapshot(pendingQuery, (snapshot) => {
      const pending = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
      setPendingRentalCount(pending.length);
      setPendingRentalIds(new Set(pending.map((rental) => rental.id)));
    }, (error) => {
      console.error('Pending rental listener error:', error);
      setPendingRentalCount(0);
      setPendingRentalIds(new Set());
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return { pendingRentalCount, pendingRentalIds };
}